import React from "react";
import Loadable from "react-loadable";

import DotSpinner from "@exovera/dot-spinner";

function Loading() {
	return (
		<div className="breadcrumb__loader">
			<DotSpinner color="#1cc2ff" />
		</div>
	);
}
const USATinyMapLoader = Loadable.Map({
	loader: {
		Breadcrumb: () => import(/* webpackChunkName: "tinyMap" */ "components/Breadcrumb"),
		baseIcon: () => import(/* webpackChunkName: "tinyMap" */ "lib/maps/tinyAfghanistan.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const { actions } = props;
		const Breadcrumb = loaded.Breadcrumb.default;
		const baseIcon = loaded.baseIcon.default;
		return (
			<Breadcrumb
				baseIcon={baseIcon}
				stateName={props.stateName}
				clearLocationFilters={actions.clearLocationFilters}
			/>
		);
	},
});

export default USATinyMapLoader;
